import React from 'react';

import { WarningAlert } from './WarningAlert';

const IRREGULARITY_LABEL_OVERRIDE: { [key: string]: string } = {
  'Professional created shift': 'recently added shift',
  'Professional edited shift': 'recently edited shift',
};

type ShiftInReviewAlertProps = {
  openIrregularities: Array<{ label?: string | null }>;
};

export const ShiftInReviewAlert = ({ openIrregularities }: ShiftInReviewAlertProps) => {
  if (!openIrregularities.length) {
    return null;
  }

  const getLowercaseLabel = (label: string) =>
    IRREGULARITY_LABEL_OVERRIDE[label] ?? label.toLocaleLowerCase();
  const labels = openIrregularities
    .map((irregularity) => irregularity.label && getLowercaseLabel(irregularity.label))
    .filter(Boolean) as string[];
  const joinedLabels =
    labels.slice(0, -1).join(', ') + (labels.length > 1 ? ' and ' : '') + labels.slice(-1);

  return <WarningAlert description={`In review for ${joinedLabels}`} />;
};
